import { useState } from "react";
import {
  AppShell,
  Navbar,
  Header,
  Text,
  MediaQuery,
  Burger,
  useMantineTheme,
  useMantineColorScheme,
  ActionIcon,
  Flex,
  Image,
  Button,
} from "@mantine/core";
import { Template } from "./components/template/Template";
import { TemplateBase } from "./components/template/TemplateBase";
import { IconSun, IconMoonStars } from "@tabler/icons-react";
import "./styles.css";
import {
  Controls,
  defaultColours,
  defaultPattern,
} from "./components/controls/Controls.js";

export default function App() {
  const theme = useMantineTheme();
  const [opened, setOpened] = useState(false);
  const [colours, onColoursChange] = useState(defaultColours);
  const [patternType, onPatternTypeChange] = useState(defaultPattern);
  const [photoDataUrl, setPhotoDataUrl] = useState(null);
  const [showBase, setShowBase] = useState(true);
  const { colorScheme, toggleColorScheme } = useMantineColorScheme();

  const dark = colorScheme === "dark";

  return (
    <AppShell
      styles={{
        main: {
          background:
            theme.colorScheme === "dark"
              ? theme.colors.dark[3]
              : theme.colors.gray[1],
          overflowX: "hidden",
        },
        nav: {
          background:
            theme.colorScheme === "dark"
              ? theme.colors.dark[3]
              : theme.colors.dark[3],
        },
      }}
      navbarOffsetBreakpoint="sm"
      asideOffsetBreakpoint="sm"
      navbar={
        <Navbar
          p="md"
          hiddenBreakpoint="sm"
          hidden={!opened}
          width={{ sm: 200, lg: 300 }}
          style={{
            background:
              theme.colorScheme === "dark"
                ? `rgba(0,0,0,0.5)`
                : `rgba(255,255,255,0.5)`,
          }}
        >
          <Flex
            direction="column"
            justify={"space-between"}
            style={{ height: "100%" }}
          >
            <Controls
              colours={colours}
              onColoursChange={onColoursChange}
              patternType={patternType}
              onPatternTypeChange={onPatternTypeChange}
              photoDataUrl={photoDataUrl}
              onPhotoChange={setPhotoDataUrl}
              showBase={showBase}
              onShowBaseChange={setShowBase}
            />

            <Button
              component="a"
              href="https://artfly.io/"
              target="_blank"
              rel="noopener noreferrer"
              variant="subtle"
              color="gray"
              leftIcon={
                <Image
                  style={{ display: "inline-block" }}
                  width={20}
                  height={20}
                  fit="contain"
                  src="./img/artfly-logo_30x30.png"
                />
              }
            >
              an ArtFly project
            </Button>
          </Flex>
        </Navbar>
      }
      header={
        <Header height={{ base: 50, md: 70 }} p="md">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              height: "100%",
            }}
          >
            <MediaQuery largerThan="sm" styles={{ display: "none" }}>
              <Burger
                opened={opened}
                onClick={() => setOpened((o) => !o)}
                size="sm"
                color={theme.colors.gray[6]}
                mr="xl"
              />
            </MediaQuery>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                height: "100%",
              }}
            >
              <Image
                style={{ display: "inline-block", marginRight: 10 }}
                width={20}
                height={20}
                fit="contain"
                src="./img/domeIcon_30x30.png"
              />
              <Text>Geodesic Dome Maker</Text>
            </div>

            <ActionIcon
              variant="outline"
              color={dark ? "yellow" : "blue"}
              onClick={() => toggleColorScheme()}
              title="Toggle color scheme"
            >
              {dark ? (
                <IconSun size="1.1rem" />
              ) : (
                <IconMoonStars size="1.1rem" />
              )}
            </ActionIcon>
          </div>
        </Header>
      }
    >
      <div className="template-container">
        <Template colours={colours} patternType={patternType} photoDataUrl={photoDataUrl} />
        {showBase && <TemplateBase />}
      </div>
    </AppShell>
  );
}
